import { Linking, Platform } from 'react-native';
import { t, type Lang } from '@hogar/shared';

/** Where owners write for help (company standard, section 3). */
export const SUPPORT_EMAIL = 'support@dejodicho.com';
export const APP_VERSION = '0.1.0';

/** The running build, so Mike can ask "what does Help say?": the version plus the web build's file id. */
export function buildLabel(): string {
  if (Platform.OS !== 'web' || typeof document === 'undefined') return APP_VERSION;
  const entry = Array.from(document.scripts, (s) => s.src.split('/').pop() ?? '').find((n) => n.startsWith('entry-'));
  return entry ? `${APP_VERSION} (${entry.replace(/^entry-|\.js$/g, '').slice(0, 8)})` : APP_VERSION;
}

let ownerEmail = '';
/** The signed-in owner's email, carried by the Get help email so Mike can find their account. */
export function setHelpEmail(email: string) {
  ownerEmail = email;
}

/**
 * Opens an email to support carrying only the app version, the screen, the reference, and the
 * signed-in email (company standard, section 6). Never on pages opened from a link.
 */
export function openHelpEmail(lang: Lang, reference?: string) {
  const screen = Platform.OS === 'web' && typeof location !== 'undefined' ? location.pathname : '';
  const ref = reference ?? '—';
  const lines = [t(lang, 'helpBody'), '', '', '—', `Version: ${buildLabel()}`, `Screen: ${screen || '—'}`, `Reference: ${ref}`, `Email: ${ownerEmail || '—'}`];
  const url = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(t(lang, 'helpSubject', { ref }))}&body=${encodeURIComponent(lines.join('\n'))}`;
  if (Platform.OS === 'web') window.location.href = url;
  else void Linking.openURL(url);
}
